import { AdminUser, CreateAdminUserRequest, UpdateAdminUserRequest } from '@/typings/entity/adminUser';
import { useEditDrawerState, useTableDataSource } from '@/helpers/hooks';
import { Store } from 'antd/lib/form/interface';
import { useCreateAdminUserApi, useUpdateAdminUserApi } from '@/api/adminUsers';

export function useAdminListHelper() {
  const editDrawer = useEditDrawerState<AdminUser>('id', [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => (a.name > b.name ? 1 : -1),
    },
  ]);
  const dataSource = useTableDataSource<AdminUser>();

  const createApi = useCreateAdminUserApi();
  const updateApi = useUpdateAdminUserApi();
  const onSubmit = (values: Store) => {
    const { name, password } = values;
    const payload: CreateAdminUserRequest | UpdateAdminUserRequest = {
      name,
    };
    if (password.length > 0) {
      payload.password = password;
    }
    if (editDrawer.mode === 'create') {
      createApi(payload).then((res) => {
        dataSource.push(res);
        editDrawer.close();
      });
    } else {
      // edit
      const next = {
        ...payload,
        id: editDrawer.identifier as number,
      };
      updateApi(next).then(() => {
        dataSource.replace('id', next);
        editDrawer.close();
      });
    }
  };

  return {
    dataSource,
    onSubmit,
    editDrawer,
  };
}
